import { Layout } from 'antd';
import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './submenu.module.css';

interface Props {
  contentType?: 'hover' | 'default';
  openSubmenu: boolean;
  submenuContent: ReactNode;
}

const SubMenu = ({ submenuContent, openSubmenu, contentType = 'default' }: Props): JSX.Element => {
  const { Sider } = Layout;

  return (
    <div className={clsx(styles.container, 'submenu', { [styles.active]: contentType === 'hover' })}>
      <Sider width={222} trigger={null} collapsible collapsed={!openSubmenu} style={{ height: '100%' }}>
        {openSubmenu && <div className={styles.contentContainer}>{submenuContent}</div>}
      </Sider>
    </div>
  );
};

export default SubMenu;
